module.exports = __webpack_public_path__ + "img/my-cards.788811d2.png";